import { render, staticRenderFns } from "./AvisoNotificaciones.vue?vue&type=template&id=96f46b3a"
import script from "./AvisoNotificaciones.vue?vue&type=script&lang=js"
export * from "./AvisoNotificaciones.vue?vue&type=script&lang=js"
import style0 from "./AvisoNotificaciones.vue?vue&type=style&index=0&id=96f46b3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports